import React, { useContext } from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import { LocaleContext } from './Layout';
import { useLocalStorage } from '../../hooks/useLocalStorage';

type Props = {
  to: string;
  tabIndex?: number;
  noLang?: boolean;
  blog?: boolean;
  props?: {};
};

/** Use the globally available context to choose the right path */
const LocalisedLink: React.FC<Props> = ({
  to,
  tabIndex,
  noLang,
  blog,
  ...props
}) => {
  const [browserLocation] = useLocalStorage('browserLocation');
  const {
    locale: pageContextLocale,
    product,
    location,
  } = useContext(LocaleContext);
  const locale = browserLocation || pageContextLocale;

  const prefix =
    locale === 'en' ? '' : blog || noLang ? '' : `/${locale?.toLowerCase()}`;

  // If the link is null we assume that we are going to use the default call to action link. This link will change depending on the context of the product. Safety products should send people to the saferme app for signup. everything else gets pushed to a lead form via the pricing page.
  const defaultTo = product === "safety" ? "/sign-up" : "/book-a-meeting-nz";

  if (to === null && locale === 'en-NZ') {
    return (
      <a
        {...props}
        tabIndex={tabIndex}
        href={defaultTo}
      />
    );
  }
  if (to === null && location.pathname === '/en-nz/') {
    return (
      <a
        {...props}
        tabIndex={tabIndex}
        href={defaultTo}
      />
    );
  }
  if (to === null) {
    return (
      <a {...props} tabIndex={tabIndex} href={defaultTo} />
    );
  }

  // If it's the default language, don't do anything
  // If it's another language, add the "path"
  // However, if the homepage/index page is linked don't add the "to"
  // Because otherwise this would add a trailing slash

  const modifiedTo = to === '/' ? '' : to;

  const path = `${prefix}${modifiedTo}`;

  const internal = /^\/(?!\/)/.test(to);

  if (internal) {
    <Link {...props} tabIndex={tabIndex} to={path} />;
  }

  return <a {...props} tabIndex={tabIndex} href={path} />;
};

LocalisedLink.propTypes = {
  to: PropTypes.string,
  tabIndex: PropTypes.number,
  noLang: PropTypes.bool,
  blog: PropTypes.bool,
  props: PropTypes.object,
};

export default LocalisedLink;
